import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { HeaderGuestMenuToggleButton } from '@/components/modules/Layout/Header/Guest/Button/HeaderGuestMenuToggleButton';
import { Logo } from '@/components/ui/Image/SvgImage/Logo';
import { topPath } from '@/utils/router/links';
/**
 * ヘッダー：ゲスト用のロゴ表示用Card
 * @param props
 * @returns
 */
export const HeaderGuestLogoCard = (props) => {
    const { className = '', hideMenu } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex items-center', 'h-[60px]', 'bg-white', 'px-20', className) }, { children: [_jsx(RouterLink, Object.assign({ to: topPath() }, { children: _jsx(Logo, { className: clsx('w-[120px] h-[30px]'), color: 'primary' }) })), _jsx(HeaderGuestMenuToggleButton, { className: clsx('ml-auto'), isOpen: true, onClickMenu: hideMenu })] })));
};
